import { ChangeDetectionStrategy, Component, inject } from '@angular/core'

import {
  FLX_MODAL_DATA,
  FlxButtonComponent,
  FlxModalComponent,
  FlxModalService,
} from '@flowx/angular-ui-toolkit'

@Component({
  selector: 'flx-information-modal-component',
  templateUrl: 'information-modal-component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [FlxButtonComponent, FlxModalComponent],
})
export class InformationModalComponent {
  #data = inject(FLX_MODAL_DATA)
  #flxModalService = inject(FlxModalService)
  title = this.#data.title || ''
  subtitle = this.#data.subtitle || ''
  message = this.#data.message || ''

  close(): void {
    this.#flxModalService.hide()
  }
}
